const doctorTypeEnum = new Map()
doctorTypeEnum.set(1, '医生')
doctorTypeEnum.set(2, '护士')
doctorTypeEnum.set(3, '医技')
doctorTypeEnum.set(4, '药师')

const approvalStatusEnum = new Map()
approvalStatusEnum.set(1, '未提交')
approvalStatusEnum.set(2, '待审核')
approvalStatusEnum.set(3, '通过')
approvalStatusEnum.set(4, '驳回')

const registerStatusEnum = new Map()
const registerStatusList = ['提交', '已提交', '通过', '驳回']
const orderTypeEnum = new Map()
const ReviewOrderEnum = new Map()
const ReviewOrderEnum1 = new Map()
const orderTypeList = ['全病程订单', '药品订单', '问诊订单']
// const orderPayStatus = [
//     '待支付',
//     '已支付',
//     '已取消',
//     '退款',
//     '配送'
// ]
/**处方类型 */
const prescriptionList = [
  '西药处方',
  '中药处方',
  '营养处方',
  '运动处方',
  '治疗处方',
]
/**审核状态 */
const ReviewOrderList = ['待审核', '通过', '驳回']
/**审核状态2 */
const ReviewOrderList1 = ['未提交', '已提交', '通过', '驳回']
registerStatusList.forEach((item, index) => {
  registerStatusEnum.set(index + 1, item)
})
orderTypeList.forEach((item, index) => {
  orderTypeEnum.set(index + 1, item)
})
prescriptionList.forEach((item, index) => {
  orderTypeEnum.set(index + 1, item)
})
ReviewOrderList.forEach((item, index) => {
  ReviewOrderEnum.set(index + 1, item)
})
ReviewOrderList1.forEach((item, index) => {
  ReviewOrderEnum1.set(index + 1, item)
})

export default {
  doctorType: doctorTypeEnum,
  approvalStatus: approvalStatusEnum,
  registerStatus: registerStatusEnum,
  orderTypeStatus: orderTypeEnum,
  prescription: orderTypeEnum,
  ReviewOrder: ReviewOrderEnum,
  ReviewOrder1: ReviewOrderEnum1,
}
